<template>
    <nio-dropdown v-if="locales.length > 1">
        <template #trigger>
            <button class="inline-flex items-center" tabindex="-1">
                {{ selectedLocale.label }}
                <nio-icon class="ml-2 text-xs" name="regular/arrow-down-1" />
            </button>
        </template>
        <nio-dropdown-item
            :key="locale.value"
            @click="$emit('input', locale.value)"
            v-for="locale in locales"
        >
            {{ locale.label }}
        </nio-dropdown-item>
    </nio-dropdown>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                required: true,
            },
            locales: {
                type: Array,
                required: true,
            },
        },

        computed: {
            selectedLocale() {
                return this.locales.find(locale => locale.value === this.value);
            },
        },
    };
</script>
